import { utilizationAlertsSelector } from "./utilizationAlertsSelector";
import { RootState } from "../../../store";

export const utilizationAlertByIdSelector = (state: RootState, id: string) => {
  const alerts = utilizationAlertsSelector(state);

  return alerts?.find((alert) => alert.id === id);
};
